<div
  class="d-flex flex-column align-items-center"
  style="color: var(--color-white)"
>
  <div class="Blog_img_wrapper">
    <img
      class="Blog_img"
      [src]="getImage(item?.attributes?.image.data.attributes.url)"
      alt="Blog_image"
    />
    <img
      class="gradient_img"
      src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/blog_gradient_img.png"
      alt="gradient_image"
    />
  </div>
  <div class="Blog_card">
    <h2 class="headingWL">
      {{ gettitle(item?.attributes.title)
      }}<span class="red"> {{ gettitle(item?.attributes.title, true) }}</span>
    </h2>
    <div class="Blog_Detail">
      <p class="Blog_date">
        {{ Date(item?.attributes?.publishedAt) }} |
        {{ item?.attributes?.category?.data?.attributes?.name }}
      </p>
      <p class="Writer_name">Author: {{ item?.attributes?.meta?.author }}</p>
      <p class="vtext" [innerHTML]="item?.attributes?.content"></p>
    </div>
  </div>
</div>
